import type { NestedI18nObject } from '../../utils';

const admin: NestedI18nObject = {
  // Admin Pages
  subPage: {
    title: 'This page can only be viewed by Admin',
    alertMessage: 'Umi ui is now released, welcome to use npm run ui to start the experience.',
  },
};

export default admin;
